module.exports = __webpack_public_path__ + "static/img/gr-img5.77e1a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gr-img5.jpg
// module id = 577
// module chunks = 0